<template>
  <span>
    <div class="pergunta" v-if="perguntaResponder.exibe">
      <div class="perguntaContent">
        <table>
          <tbody>
            <tr v-b-tooltip.hover :title="perguntaResponder.hint">
              <td><span v-html="perguntaResponder.numero + ') ' + perguntaResponder.titulo" style="font-size: 14px"/></td>
              <td>&nbsp;&nbsp;</td>
              <td><span v-if="perguntaResponder.required" class="bold text-danger">*</span></td>
              <td><span v-if="perguntaResponder.hint"><i class="fa fa-info-circle"></i></span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <b-col class="col-md-12 col-sm-12" v-if="perguntaResponder.tipo == 'CA' && !disabled ||
                        visualizarQuestionario && perguntaResponder.tipo == 'CA'">
          <b-form-group>
              <div class="row">
                <div class="col-md-4 col-sm-12">
                  <ejs-uploader
                    :ref="'file' + perguntaResponder.id"
                    :id="'file' + perguntaResponder.id"
                    :name="'file' + perguntaResponder.id"
                    :asyncSettings="path"
                    :locale="locale"
                    allowedExtensions=".jpg, .jpeg"
                    maxFileSize="1073741824"
                    :uploading="carregar"
                    :success="sucesso"
                    :removing="remover"
                    :pausing="decrementar"
                    :resuming="incrementar"
                    :canceling="decrementar"
                    :failure="sucesso"/>
                </div>
                <b-col class="col-md-5 col-sm-12" v-if="perguntaResponder.tipo == 'CA' && disabled && !visualizarQuestionario">
                <b-form-group v-for="(arquivo, index) in perguntaResponder.resposta.respostaUpload" :key="index">
                  <a @click="endereco(arquivo.nome)">
                    <b-button block variant="primary">
                      <i class="fa fa-download"></i>&nbsp;<span>{{ obterNomeArquivo(arquivo.nome) }}</span>
                    </b-button>
                  </a>
                </b-form-group>
              </b-col>
              </div>
              <br />
              <div class="row">
                <div class="col-md-2 col-sm-12">
                  <b-button block variant="primary" :disabled="disabled" v-on:click="openModal()">
                    <span>Abrir Câmera</span>
                  </b-button>
                </div>
                <div style="padding-top: 0.4%" class="col-md-2 col-sm-12" 
                  v-if="perguntaResponder.resposta.respostaUpload[0] 
                    && perguntaResponder.resposta.respostaUpload[0].data && !$disabled"
                >
                  <label>
                    <b>Sua foto foi guardada com sucesso!</b>
                  </label>
                </div>
              </div>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser fornecido uma imagem para responder a pergunta.</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col class="col-md-12 col-sm-12" v-if="perguntaResponder.tipo == 'CA' && disabled && !visualizarQuestionario">
          <b-form-group v-for="(arquivo, index) in perguntaResponder.resposta.respostaUpload" :key="index">
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <b-img :src="arquivo['data']" fluid></b-img>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-md-3 col-sm-12" v-if="perguntaResponder.tipo == 'CP'">
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="perguntaResponder.resposta.respostaTexto"
                :placeholder=" impressao ? '' : '00000-000'"
                v-mask="'#####-###'"
                v-on:blur="finalizarTexto"
                :disabled="disabled"
                :state="chkState('respostaTexto')"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser informado um CEP para responder esta pergunta.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-3 col-sm-12" v-if="perguntaResponder.tipo == 'HR'">
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="perguntaResponder.resposta.respostaTexto"
                :placeholder=" impressao ? '' : '00:00:00'"
                v-mask="'##:##:##'"
                :disabled="disabled"
                :state="chkState('respostaTexto')"
                v-on:blur="finalizarTexto"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser informado um horário para responder esta pergunta.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-3 col-sm-12" v-if="perguntaResponder.tipo == 'ND'">
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="perguntaResponder.resposta.respostaTexto"
                :placeholder="impressao ? '' : '00.00'"
                type="number"
                :disabled="disabled"
                :state="chkState('respostaTexto')"
                v-on:blur="finalizarTexto"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser informado um número decimal para responder esta pergunta.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-4 col-sm-12" v-if="perguntaResponder.tipo == 'EM'">
          <b-form-group>
            <b-input-group>
               <b-form-input
                  class="form-control"
                  v-model="perguntaResponder.resposta.respostaTexto"
                  :state="chkState('respostaTexto')">
                  </b-form-input>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                      endereço de e-mail válido.
                    </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-3 col-sm-12" v-if="perguntaResponder.tipo == 'NI'">
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="perguntaResponder.resposta.respostaTexto"
                :placeholder="impressao ? '' : '0'"
                :disabled="disabled"               
                 maxlength="11"
                :state="chkState('respostaTexto')"
                v-on:blur="finalizarTexto"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser informado um número inteiro para responder esta pergunta.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-7 col-sm-12" v-if="perguntaResponder.tipo == 'TX'">
          <b-form-group>
            <b-input-group>
              <b-form-textarea
                v-model="perguntaResponder.resposta.respostaTexto"
                no-resize
                :disabled="disabled || perguntaResponder.disabled"
                :rows="sizeRow(perguntaResponder.size)"
                :state="chkStateTextoLivre()"
                v-on:blur="finalizarTexto"
              ></b-form-textarea>
              <b-form-invalid-feedback
                v-if="lengthTextoLivre > perguntaResponder.size"
                id="input1LiveFeedback3"
              >Resposta não pode passar de {{perguntaResponder.size}} caracteres.
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else id="input1LiveFeedback3">Resposta obrigatória.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-5 col-sm-12" v-if="perguntaResponder.tipo == 'UP' && !disabled ||
                        visualizarQuestionario && perguntaResponder.tipo == 'UP'">
          <ejs-uploader
            :ref="'file' + perguntaResponder.id"
            :id="'file' + perguntaResponder.id"
            :name="'file' + perguntaResponder.id"
            :asyncSettings="path"
            :locale="locale"
            allowedExtensions=".jpg, .mp4, .pdf, .doc, .docx, .xls, .xlsx"
            maxFileSize="1073741824"
            :uploading="carregar"
            :success="sucesso"
            :removing="remover"
            :pausing="decrementar"
            :resuming="incrementar"
            :canceling="decrementar"
            :failure="sucesso"/>
          <b-form-invalid-feedback :state="chkState('respostaUpload')">É necessário anexar arquivo(s) para responder esta pergunta.</b-form-invalid-feedback>
        </b-col>
        <b-col class="col-md-5 col-sm-12" v-if="perguntaResponder.tipo == 'UP' && disabled && !visualizarQuestionario">
          <b-form-group v-for="(arquivo, index) in perguntaResponder.resposta.respostaUpload" :key="index">
            <a @click="endereco(arquivo.nome)">
              <b-button block variant="primary">
                <i class="fa fa-download"></i>&nbsp;<span>{{ obterNomeArquivo(arquivo.nome) }}</span>
              </b-button>
            </a>
          </b-form-group>
        </b-col>
        <b-col class="col-md-4 col-sm-12" v-if="perguntaResponder.tipo == 'DT'">
          <b-form-group>
            <b-input-group>
              <b-form-datepicker
                locale="pt-BR"
                v-model="perguntaResponder.resposta.respostaTexto"
                :placeholder="impressao ? '' : 'dd/mm/aaaa'"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                aria-controls="example-input"
                :disabled="disabled || perguntaResponder.disabled"
                :state="chkState('respostaTexto')"
                v-on:blur="finalizarTexto"
              ></b-form-datepicker>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser informada uma data para responder esta pergunta.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-10 col-sm-12" v-if="perguntaResponder.tipo == 'ME'">
          <b-form-group>
            <b-form-checkbox-group
              :id="perguntaResponder.id + 'check-group'"
              v-model="perguntaResponder.resposta.respostaOp"
              :options="perguntaResponder.opcoes"
              value-field="id"
              stacked
              text-field="resposta"
              :disabled="disabled"
              :name="perguntaResponder.id + 'check-group'"
              :state="chkState('respostaOp')"
            ></b-form-checkbox-group>
            <b-form-invalid-feedback
              id="input1LiveFeedback3"
            >Deve ser selecionado uma ou mais opções para responder esta pergunta.</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col class="col-md-10 col-sm-12" v-if="perguntaResponder.tipo == 'UE'">
          <b-form-group>
            <b-form-radio-group stacked v-model="perguntaResponder.resposta.respostaOp" :state="chkState('respostaOp')">
              <b-form-radio
                v-for="(opcao, indexOpcao) in perguntaResponder.opcoes"
                :key="indexOpcao"
                class="radio-button"
                :v-model="perguntaResponder.resposta.respostaOp"
                :disabled="disabled"
                :value="opcao.id"
                :name="perguntaResponder.id + 'radio'"
              >{{opcao.resposta}}</b-form-radio>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser selecionada uma opção para responder esta pergunta.</b-form-invalid-feedback>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-3 col-sm-12" v-if="perguntaResponder.tipo == 'CF'">
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="perguntaResponder.resposta.respostaTexto"
                :placeholder="impressao ? '' : '000.000.000-00'"
                v-mask="'###.###.###-##'"
                v-on:blur="finalizarTexto"
                :disabled="disabled"
                v-on:change="getConfigCpf"
                :state="chkState('respostaTexto')"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser informado um CPF para responder esta pergunta.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-3 col-sm-12" v-if="perguntaResponder.tipo == 'CJ'">
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="perguntaResponder.resposta.respostaTexto"
                :placeholder="impressao ? '' : '00.000.000/0000-00'"
                v-mask="'##.###.###/####-##'"
                v-on:blur="finalizarTexto"
                :disabled="disabled"
                v-on:change="getConfigCnpj"
                :state="chkState('respostaTexto')"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser informado um CNPJ para responder esta pergunta.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-3 col-sm-12" v-if="perguntaResponder.tipo == 'TE'">
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="perguntaResponder.resposta.respostaTexto"
                :placeholder=" impressao ? '' : '(00)00000-0000'"
                v-mask="'(##)#####-####'"
                v-on:blur="finalizarTexto"
                :disabled="disabled || perguntaResponder.disabled"
                :state="chkState('respostaTexto')"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input1LiveFeedback3"
              >Deve ser informado um Telefone para responder esta pergunta.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-md-12 col-sm-12" v-if="perguntaResponder.tipo == 'UM'">
          <b-form-group
            class="col-md-3 col-sm-12"
            style="display: inline-block"
            label="UF:"
            :state="chkState('uf_id')"
            invalid-feedback='É obrigatório informar a UF.'>
            <multiselect
              v-model="ufSelecionada"
              :options="estados"
              label="sigla"
              track-by="id"
              placeholder="Selecione"
              selectLabel="Selecionar"
              deselectLabel="Remover"
              selectedLabel="Selecionado"
              return="id"
              :disabled="disabled || perguntaResponder.disabled"
              :multiple="false"
              @input="opt => perguntaResponder.resposta.uf_id = opt.id"
              :state="chkState('uf_id')">
            </multiselect>
          </b-form-group>
          <b-form-group
            class="col-md-5 col-sm-12"
            style="display: inline-block"
            label="Cidade:"
            :state="chkState('cidade_id')"
            invalid-feedback='É obrigatório informar a Cidade.'>
            <multiselect
              v-model="cidadeSelecionada"
              :options="cidades"
              label="cidade"
              track-by="id"
              placeholder="Selecione"
              selectLabel="Selecionar"
              deselectLabel="Remover"
              selectedLabel="Selecionado"
              return="id"
              :disabled="disabled || perguntaResponder.disabled || !perguntaResponder.resposta.uf_id"
              :multiple="false"
              @input="opt => perguntaResponder.resposta.cidade_id = opt.id"
              :state="chkState('cidade_id')">
            </multiselect>
          </b-form-group>
        </b-col>
      </div>
    </div>
    <b-modal
      title="Captura de imagens"
      size="lg"
      ok-title="Tirar Foto"
      cancel-title="Cancelar"
      v-model="modalControl"
      @ok="onCapture()"
      @shown="onStart()"
    >
      <b-card-body>
        <h2>Dispositivo Atual</h2>
        <div class="col-md-12">
          <b-form-select v-model="camera" placeholder="Selecione o dispositivo" class="mb-3">
            <option
              v-for="device in devices"
              :key="device.deviceId"
              :value="device.deviceId"
            >{{ device.label }}</option>
          </b-form-select>
        </div>
        <div class="col-md-12">
          <vue-web-cam
            ref="webcam"
            :device-id="deviceId"
            width="100%"
            @cameras="onCameras"
            @camera-change="onCameraChange"
          />
        </div>
      </b-card-body>
    </b-modal>
    <b-modal
      title="Confirmação de foto"
      size="lg"
      ok-title="Usar esta"
      cancel-title="Tirar Novamente"
      v-model="modalConfirm"
      @ok="confirmCapture()"
      @cancel="captureAgain()"
    >
      <b-card-body>
        <div class="col-md-12">
          <h2>Imagem Capturada</h2>
          <figure class="figure">
            <img :src="img" class="img-responsive" />
          </figure>
        </div>
      </b-card-body>
    </b-modal>
  </span>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import {
  required, email
} from 'vuelidate/lib/validators'
import { WebCam } from 'vue-web-cam'
import FileUpload from 'vue-upload-component'
import miniToastr from 'mini-toastr'
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs'
import { L10n } from '@syncfusion/ej2-base'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

Vue.use(UploaderPlugin)

L10n.load({
  'pt-BR': {
    uploader: {
      invalidMinFileSize: 'O tamanho do arquivo é muito pequeno! Por favor, carregue um arquivo com tamanho mínimo de 10 KB',
      invalidMaxFileSize: 'O tamanho do arquivo ultrapassa 28MB',
      invalidFileType: 'O tipo do arquivo não é permitido',
      Browse: 'Selecionar',
      Clear: 'Limpar',
      Upload: 'Carregar',
      dropFilesHint: 'ou depositar arquivos aqui',
      uploadFailedMessage: 'Impossível carregar o arquivo',
      uploadSuccessMessage: 'Arquivo carregado com sucesso',
      removedSuccessMessage: 'Arquivo removido com sucesso',
      removedFailedMessage: 'Arquivo não pode ser removido',
      inProgress: 'Carregando',
      readyToUploadMessage: 'Pronto para carregar',
      remove: 'Remover',
      cancel: 'Cancelar',
      delete: 'Remover o arquivo'
    }
  }
})

miniToastr.init()

export default {
  name: 'perguntaResponder',
  props: ['perguntaResponder', 'secao', 'salvarForm', 'disabled', 'visualizarQuestionario', 'diretorio', 'impressao', 'configCpf', 'configCnpj', 'camposConfiguracaoCpf', 'camposConfiguracaoCnpj'],
  components: {
    VueSelect,
    FileUpload,
    Multiselect,
    'vue-web-cam': WebCam
  },
  mixins: [validationMixin],
  validations: {
    perguntaResponder: {
      respostaOp: { required },
      respostaUpload: { required },
      respostaTexto: { required },
      email: {
        email
      }
    }
  },
  created () {
    if (this.perguntaResponder.tipo == 'UM') {
      this.$emit('getUM')
    }
  },
  beforeMount () {
    this.perguntaResponder.resposta.respostaUpload.forEach((element, index) => {
      const data = {
        name: element.nome,
        size: 'N/A',
        id: index,
        old: '',
        link: element.data,
        file: null
      }

      this.arquivosSelecionados.push(data)
    })

    if (this.perguntaResponder.tipo == 'ME' && this.perguntaResponder.resposta.respostaOp == null) {
      this.perguntaResponder.resposta.respostaOp = []
    }

    if (this.perguntaResponder.resposta.uf_id) {
      this.estados.forEach((estado) => {
        if (estado.id == this.perguntaResponder.resposta.uf_id) {
          this.ufSelecionada = estado
        }
      })
    }

    if (this.perguntaResponder.resposta.cidade_id) {
      this.cidadesEstados[this.perguntaResponder.resposta.uf_id].forEach((cidade) => {
        if (cidade.id == this.perguntaResponder.resposta.cidade_id) {
          this.cidadeSelecionada = cidade
        }
      })
    }
  },
  data () {
    return {
      labels: {
        labelPrevDecade: 'Década anterior',
        labelPrevYear: 'Ano anterior',
        labelPrevMonth: 'Mês anterior',
        labelCurrentMonth: 'Mês atual',
        labelNextMonth: 'Próximo mês',
        labelNextYear: 'Próximo ano',
        labelNextDecade: 'Pŕoxima década',
        labelToday: 'Hoje',
        labelSelected: 'Data selecionada',
        labelNoDateSelected: 'Nenhuma data selecionada',
        labelCalendar: 'Calendário',
        labelNav: 'Controles do calendário',
        labelHelp: 'Use as setas para navegar pelas datas do calendário',
        labelResetButton: 'Limpar'
      },
      arquivoValidFailSize: false,
      arquivosSelecionados: [],
      ufSelecionada: null,
      cidadeSelecionada: null,
      modalControl: false,
      modalConfirm: false,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      opcoes: this.perguntaResponder.resposta.respostaOp,
      path: {
        saveUrl: process.env.ROOT_API1 + 'api/uploadFile',
        removeUrl: process.env.ROOT_API1 + 'api/removeFile'
      },
      locale: 'pt-BR'
    }
  },
  watch: {
    'respostasPai.respostaOp': function (newVal, oldVal) {
      if (this.tipoPai == 'UE' || this.tipoPai == 'ME') {
        if (Array.isArray(this.respostasPai.respostaOp)) {
          this.perguntaResponder.exibe = this.respostasPai.respostaOp.includes(this.perguntaResponder.opcaoDependente)
        } else if (this.respostasPai.respostaOp == this.perguntaResponder.opcaoDependente) {
          this.perguntaResponder.exibe = true
        } else {
          this.perguntaResponder.exibe = false
        }
      }
    },
    'respostasPai': {
      handler (newVal, oldVal) {
        if (this.tipoPai == 'TX' ||
          this.tipoPai == 'TE' ||
          this.tipoPai == 'CJ' ||
          this.tipoPai == 'CP' ||
          this.tipoPai == 'CF' ||
          this.tipoPai == 'DT' ||
          this.tipoPai == 'NI' ||
          this.tipoPai == 'ND' ||
          this.tipoPai == 'HR' ||
          this.tipoPai == 'UM') {
          if (newVal != null && newVal != '') {
            this.perguntaResponder.exibe = true
          } else {
            this.perguntaResponder.exibe = false
          }
        }

        if (this.tipoPai == 'UP' || this.tipoPai == 'CA') {
          if (newVal != null && newVal != '' && newVal.length > 0) {
            this.perguntaResponder.exibe = true
          } else {
            this.perguntaResponder.exibe = false
          }
        }
      },
      deep: true
    },
    'arquivosSelecionados': function () {
      this.perguntaResponder.resposta.respostaUpload = []
      for (let i = 0; i < this.arquivosSelecionados.length; i++) {
        if (this.arquivosSelecionados[i].file != null) {
          let reader = new FileReader()
          reader.readAsDataURL(this.arquivosSelecionados[i].file)
          reader.onload = () => {
            this.perguntaResponder.resposta.respostaUpload.push({nome: this.arquivosSelecionados[i].name, data: reader.result})
          }
        }
        if (this.arquivosSelecionados[i].link) {
          this.perguntaResponder.resposta.respostaUpload.push({nome: this.arquivosSelecionados[i].name, data: this.arquivosSelecionados[i].link})
        }
      }
    },
    exibicaoPai: function () {
      if (!this.exibicaoPai) {
        this.clearPergunta()
        this.perguntaResponder.exibe = false
      }
    },
    camera: function (id) {
      this.deviceId = id
    },
    devices: function () {
      const first = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      }
    },
    salvarForm: function () {
      this.validate()
    },
    'perguntaResponder.resposta.respostaOp': function (newVal, oldVal) {
      if (Array.isArray(newVal)) {
        newVal = newVal[(this.perguntaResponder.resposta.respostaOp.length - 1)]
      }

      this.perguntaResponder.opcoes.forEach(element => {
        if (element.id == newVal && element.finaliza_questionario) {
          this.$bvModal.msgBoxConfirm('Essa pergunta finalizará o formulário. Deseja continuar?', {
            okTitle: 'Confirmar',
            cancelTitle: 'Cancelar'
          }).then(valor => {
            if (valor) {
              this.$emit('finalizarQuestionario', this.perguntaResponder.id)
            } else {
              this.perguntaResponder.resposta.respostaOp = oldVal
            }
          }).catch(erro => {
            console.log(erro)
          })
        }
      })
    },
    'perguntaResponder.resposta.respostaUpload': function (newVal) {
      if (newVal) {
        this.validaFinaliza()
      }
    },
    'estados': function () {
      // failsafe em caso de delay no request
      if (!this.ufSelecionada && this.perguntaResponder.resposta.uf_id) {
        this.estados.forEach((estado) => {
          if (estado.id == this.perguntaResponder.resposta.uf_id) {
            this.ufSelecionada = estado
          }
        })
      }
    },
    'cidadesEstados': function () {
      // failsafe em caso de delay no request
      if (!this.cidadeSelecionada && this.perguntaResponder.resposta.cidade_id) {
        this.cidadesEstados[this.perguntaResponder.resposta.uf_id].forEach((cidade) => {
          if (cidade.id == this.perguntaResponder.resposta.cidade_id) {
            this.cidadeSelecionada = cidade
          }
        })
      }
    },
    'perguntaResponder.exibe': function (val) {
      if (!val) {
        this.clearPergunta()
      }
    }
  },
  computed: {
    ...mapState({
      carregando: state => state.resposta.carregando
    }),
    estados () {
      return this.$store.state.estado.estados
    },
    cidadesEstados () {
      return this.$store.getters.getCidadesEstadoCombo
    },
    cidades () {
      let cidades = []
      if (this.perguntaResponder.resposta.uf_id) {
        cidades = this.cidadesEstados[this.perguntaResponder.resposta.uf_id]
      }
      return cidades
    },
    respostasPai () {
      if (this.perguntaResponder.dependente) {
        return this.secao.pergunta[this.perguntaResponder.posicaoPai].resposta
      } else {
        return null
      }
    },
    exibicaoPai () {
      if (this.perguntaResponder.dependente) {
        return this.secao.pergunta[this.perguntaResponder.posicaoPai].exibe
      } else {
        return null
      }
    },
    tipoPai () {
      if (this.perguntaResponder.dependente) {
        return this.secao.pergunta[this.perguntaResponder.posicaoPai].tipo
      } else {
        return null
      }
    },
    device () {
      return this.devices.find((n) => n.deviceId == this.deviceId)
    },
    lengthTextoLivre () {
      let length = 0

      if (this.perguntaResponder.resposta.respostaTexto != null) {
        length = this.perguntaResponder.resposta.respostaTexto.length
      }

      return length
    }
  },
  methods: {
    clearPergunta () {
      if (this.perguntaResponder.tipo == 'ME') {
        this.perguntaResponder.resposta.respostaOp = []
      } else {
        this.perguntaResponder.resposta.respostaOp = null
      }

      this.perguntaResponder.resposta.respostaTexto = null
      this.perguntaResponder.resposta.respostaUpload = null
      this.perguntaResponder.resposta.uf_id = null
      this.perguntaResponder.resposta.cidade_id = null
    },
    finalizarTexto () {
      if (this.perguntaResponder.resposta.respostaTexto != null) {
        this.validaFinaliza()
      }
    },
    validaFinaliza () {
      if (this.perguntaResponder.finaliza_questionario) {
        this.$bvModal.msgBoxConfirm('Essa pergunta finalizará o formulário. Deseja continuar?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) {
            this.$emit('finalizarQuestionario', this.perguntaResponder.id)
          } else {
            this.perguntaResponder.resposta.respostaUpload = null
            this.perguntaResponder.resposta.respostaTexto = null
          }
        }).catch(erro => {
          console.log(erro)
        })
      }
    },
    radioCheck (opcao) {
      return this.perguntaResponder.resposta.respostaOp
    },
    sizeRow (number) {
      let result = 0
      result = parseInt(number / 100)
      return result
    },
    getConfigCpf: function (evt) {
      if (this.configCpf) {
        let cpf = evt.replace(/[^\d]+/g, '')
        Vue.http.get('api/questionario/getServicoCpf/' + cpf).then(response => {
          var campos = response.data.data[0]
          this.secao.pergunta.forEach((element, index) => {
            var perguntaEd = element
            if (this.camposConfiguracaoCpf.pergunta_id_nome == perguntaEd.id) {
              perguntaEd.resposta.respostaTexto = campos.campo_nome
              perguntaEd.disabled = true
            }
            if (this.camposConfiguracaoCpf.pergunta_id_data_nascimento == perguntaEd.id) {
              perguntaEd.resposta.respostaTexto = campos.campo_data_nascimento
              perguntaEd.disabled = true
            }
            if (this.camposConfiguracaoCpf.pergunta_id_nome_mae == perguntaEd.id) {
              perguntaEd.resposta.respostaTexto = campos.campo_nome_mae
              perguntaEd.disabled = true
            }
          })
        })
      }
    },
    getConfigCnpj: function (evt) {
      if (this.configCnpj) {
        let cnpj = evt.replace(/[^\d]+/g, '')
        Vue.http.get('api/questionario/getServicoCnpj/' + cnpj).then(response => {
          var campos = response.data.data[0]
          this.secao.pergunta.forEach((element, index) => {
            var perguntaEd = element
            if (this.camposConfiguracaoCnpj.pergunta_id_razao_social == perguntaEd.id) {
              perguntaEd.resposta.respostaTexto = campos.campo_razao_social
              perguntaEd.disabled = true
            }
            if (this.camposConfiguracaoCnpj.pergunta_id_nome_fantasia == perguntaEd.id) {
              perguntaEd.resposta.respostaTexto = campos.campo_nome_fantasia
              perguntaEd.disabled = true
            }
            if (this.camposConfiguracaoCnpj.pergunta_id_telefone == perguntaEd.id) {
              perguntaEd.resposta.respostaTexto = campos.campo_telefone
              perguntaEd.disabled = true
            }
            if (this.camposConfiguracaoCnpj.pergunta_id_natureza_juridica == perguntaEd.id) {
              perguntaEd.resposta.respostaTexto = campos.campo_natureza_juridica
              perguntaEd.disabled = true
            }
            if (this.camposConfiguracaoCnpj.pergunta_id_representante_legal == perguntaEd.id) {
              perguntaEd.resposta.respostaTexto = campos.campo_representante_legal
              perguntaEd.disabled = true
            }
            if (this.camposConfiguracaoCnpj.pergunta_id_endereco == perguntaEd.id) {
              perguntaEd.resposta.respostaTexto = campos.campo_Endereco
              perguntaEd.disabled = true
            }
          })
        })
      }
    },
    chkState (val) {
      if (this.perguntaResponder.required && !this.disabled) {
        const field = this.perguntaResponder.resposta[val]
        if (!field && !this.salvarForm) {
          return null
        }

        return !!field
      }
    },
    chkStateTextoLivre () {
      if (this.perguntaResponder.required && !this.disabled) {
        const field = this.perguntaResponder.resposta.respostaTexto

        if (!field && !this.salvarForm) {
          return null
        }

        if (field != null && field.length > this.perguntaResponder.size) {
          return false
        }

        return true
      }
    },
    findFirstError (component = this) {
      if (component.state == false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
    },
    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile (newFile, oldFile) {
      if (newFile && !oldFile) {
        let valid = true
        if (newFile.size > 104857600) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error('Tamanho do arquivo maior que 100MB.', this.titulo_toast, 5000)
          this.$refs['upload' + this.perguntaResponder.id].remove(newFile)
          valid = false
        }

        if (newFile.type != 'image/jpeg' && newFile.type != 'application/msword' &&
            newFile.type != 'video/mpeg' && newFile.type != 'application/pdf' &&
            newFile.type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' &&
            newFile.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
            newFile.type != 'application/vnd.ms-excel' &&
            newFile.type != 'application/mp4' &&
            newFile.type != 'video/mp4') {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error('Arquivo com formato invalido.', this.titulo_toast, 5000)
          this.$refs['upload' + this.perguntaResponder.id].remove(newFile)
          valid = false
        }

        return valid
      }
    },
    downloadArquivo (link) {
      window.open(link, '_blank')
    },
    openModal () {
      this.modalControl = true
    },
    confirmCapture () {
      this.perguntaResponder.resposta.respostaUpload = [{nome: 'Captura', data: this.img}]
    },
    captureAgain () {
      this.img = null
      this.modalControl = true
    },
    onCapture () {
      this.img = this.$refs.webcam.capture()
      this.modalConfirm = true
    },
    onStop () {
      this.$refs.webcam.stop()
    },
    onStart () {
      this.$refs.webcam.start()
    },
    onCameras (cameras) {
      this.devices = cameras
    },
    onCameraChange (deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
    },
    carregar (args) {
      args.customFormData = [{diretorio: this.diretorio}, {id: this.perguntaResponder.id}]
      this.$store.commit('incrementarCarregando')

      this.perguntaResponder.resposta.respostaUpload.push({nome: args.fileData.name, diretorio: this.diretorio + '_' + this.perguntaResponder.id})
    },
    sucesso (args) {
      if (args.operation == 'upload') {
        this.$store.commit('decrementarCarregando')
      }
    },
    remover (args) {
      args.customFormData = [{diretorio: this.diretorio}, {id: this.perguntaResponder.id}]

      let index = -1
      for (let i = 0; i < this.perguntaResponder.resposta.respostaUpload.length && index == -1; i++) {
        index = this.perguntaResponder.resposta.respostaUpload[i].nome == args.filesData[0].name ? i : -1
      }

      if (index >= 0) {
        this.perguntaResponder.resposta.respostaUpload.splice(index, 1)
      }
    },
    incrementar (args) {
      this.$store.commit('incrementarCarregando')
    },
    decrementar (args) {
      this.$store.commit('decrementarCarregando')
    },
    endereco (nome) {
      window.open(process.env.ROOT_API1 + 'api/downloadFile/' + nome + '?token=' + SessionStorage.get('token'), '_blank')
    },
    obterNomeArquivo (nome) {
      return nome.indexOf('/') >= 0 ? nome.split('/')[1] : nome
    }
  }
}
</script>

<style>

p {
  margin: 0px 0px 0px 0px !important;
  padding: 0px 0px 0px 0px !important;
  display: unset !important;
}

.perguntaContent {
  margin-bottom: 1% !important;
}

.pergunta {
  margin-bottom: 3% !important;
}

</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
@import "@syncfusion/ej2-base/styles/material.css";
@import "@syncfusion/ej2-buttons/styles/material.css";
@import "@syncfusion/ej2-vue-inputs/styles/material.css";
</style>



// WEBPACK FOOTER //
// src/components/questionarios/ResponderPergunta.vue